<template>
  <div>
    <template v-if="fromPage != 'buy'">
      <g-title title="充值金额" class="c-p-tb-10 c-p-lr-20"></g-title>
      <div class="rechargeMoneyPrice">
        <ul>
          <li
            v-for="(item, index) in priceList"
            :key="index"
            :class="[
              { rechargeActive: item.Id === nowActiveRecharge.Id },
              'recharge_price_con',
            ]"
            @click="handleSelectRecharge(item)"
          >
            <p>￥{{ item.Money }}</p>
            <p class="price_con">售价{{ item.RealMoney }}元</p>
          </li>
        </ul>
        <div>
          <van-field
            v-model="otherMoney"
            type="number"
            label="其他金额"
            placeholder="点击输入金额"
            label-width="70px"
            @focus="handleFocusOtherMoneyPrice"
            @input="handleInputOtherMoneyPrices"
          />
        </div>
      </div>
    </template>
    <template v-if="fromPage != 'recharge'">
      <g-title title="次卡选择(多选)" class="c-p-tb-10 c-p-lr-20"></g-title>
      <div class="secondary_card_con">
        <van-checkbox-group
          v-model="secondaryCardResult"
          @change="handleChangeSelectStatus"
        >
          <van-cell-group>
            <van-cell
              v-for="(item, index) in secondaryCardList"
              clickable
              :key="index"
              @click="handleClickCard(item)"
            >
              <template #icon>
                <van-checkbox
                  :name="item.Id"
                  ref="checkboxes"
                  class="c-p-r-20"
                  @click.native.stop="toggle(index)"
                />
              </template>
              <template #title>
                <div class="c-fl">
                  <div class="">
                    <g-img
                      :src="item.goodsImgUrl || $root.defaultImg"
                      size="160"
                      height="60px"
                      :normal="true"
                      class="l-img c-p-r-20"
                    />
                  </div>
                  <div class="txt-box">
                    <div class="main-title">{{ item.PlanName }}</div>
                    <div class="sub-title">{{ item.TotalTimes }}</div>

                    <div>
                      <span>售价：</span>
                      <span class="c-tc">{{ item.RealMoney }}元</span>
                    </div>
                  </div>
                </div>
              </template>
              <template #right-icon>
                <div class="c-fl">
                  <g-arrow :width="16"></g-arrow>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </template>
    <div class="c-fl-bt btm c-font-34">
      <div class="b-l">
        <div>
          <span>合计:</span>
          <span class="c-yang">￥</span>
          <span>{{ allPayMoney }}</span>
        </div>
        <div class="c-fl c-font-20" v-if="fromPage != 'recharge'">
          <van-checkbox
            v-model="isCheck"
            icon-size="14"
            shape="square"
            class="check-txt"
          >
            <span>我已阅读并同意</span>
          </van-checkbox>
          <span class="c-tc c-p-l-10" @click="showModel"> 《办卡须知》</span>
        </div>
      </div>
      <div class="b-r c-f-ar">
        <div @click="confirmBuy">
          {{ fromPage != "recharge" ? "确认购买" : "确认支付" }}
        </div>
      </div>
    </div>
    <g-model :show.sync="isKnowShow" title="办卡须知">
      <ul class="cark_remark_con" v-if="cardRemarkList.length > 0">
        <li v-for="(item, index) in cardRemarkList" :key="index">
          {{ item }}
        </li>
      </ul>
      <van-empty v-else description="暂无" />
    </g-model>
    <g-model :show.sync="isCardShow" title="卡种说明">
      <!-- <template v-if="nowShowCardType != 'secondary'">
        <div class="card_img_con">
          <img :src="detailInfo.PhotoUrl || $root.defaultImg" alt="" />
        </div>

        <van-cell title="卡种名称" :value="detailInfo.CardTypeName" />
        <van-cell title="面值" :value="detailInfo.Price" />
        <van-cell title="入会费" :value="detailInfo.EnterPrice" />
        <van-cell title="折扣方案" :value="detailInfo.DiscountName" />
      </template>
      <template v-else> -->
      <div class="card_img_con">
        <img :src="detailInfo.PhotoUrl || $root.defaultImg" alt="" />
      </div>

      <van-cell title="项目名称" :value="detailInfo.PlanName" />
      <van-cell title="次数" :value="detailInfo.TotalTimes" />
      <van-cell title="售价" :value="detailInfo.RealMoney" />
      <!-- </template> -->
    </g-model>
  </div>
</template>

<script>
import { handleLocalStorage } from "@/utils";
import { getEleCardInfo } from "@/api/member";
export default {
  name: "CardRecharge",
  props: {},
  data() {
    return {
      fromPage: undefined,
      nowActiveRecharge: {},
      priceList: [],
      secondaryCardList: [],
      secondaryCardResult: [],
      detailInfo: {},
      isCheck: false,
      isKnowShow: false,
      cardRemarkList: [],
      isCardShow: false,
      otherMoney: undefined,
      cardPayMoney: 0,
      secondaryCardPayMoney: 0,
      selectCardArr: [],
      CardCode:''
    };
  },
  computed: {
    allPayMoney() {
      return this.cardPayMoney + this.secondaryCardPayMoney;
    },
  },
  created() {
    this.vpnId = this.$store.state.vpnId;
    this.cardId = this.$route.query.cardId;
    this.CardCode =  this.$route.query.cardTypeCode;
    // 当fromPage没有值时,表示第一次办卡同时充值或购买次卡;
    // fromPage为'buy'时,表示从会员卡详情页面中'购买次卡'进入该页面;
    // fromPage为'recharge'时,表示从会员卡详情页面中'充值'进入该页面;
    this.fromPage = this.$route.query.fromPage || undefined;
    if (this.fromPage == "buy") {
      // 如果从充值或购买次卡进入此页面时,清除掉之前的选择

      this.$store.commit("eleCard/setRechargeInfo", {});
    } else if (this.fromPage == "recharge") {
      this.$store.commit("eleCard/setSecondaryCardList", []);
    }
    this.handleGetRechargeList();
  },
  mounted() {},
  methods: {
    handleGetRechargeList() {
      getEleCardInfo({ id: this.CardCode, vpnId: this.vpnId }).then((res) => {
        this.priceList = res.SellPlans;
        this.secondaryCardList = res.TimesCardPlans; // 获取当前电子卡下次卡列表
        this.cardTypeName = res.CardTypeName;
        this.cardTypeId = res.Id;
        // 办卡须知
        const remark = res.Remark;
        this.cardRemarkList = remark ? remark.split(/\\n/g) : [];

        // 设置充值方案选中
        if (this.fromPage != "buy") {
          const preSelectRechargeId =
            this.$store.state.eleCard.rechargeInfoObj.Id || undefined;
          const preSelectRechargeItem = res.SellPlans.find((item) => {
            return item.Id == preSelectRechargeId;
          });
          if (preSelectRechargeId && preSelectRechargeItem) {
            this.handleSelectRecharge(preSelectRechargeItem);
          } else {
            this.handleSelectRecharge(this.priceList[0]);
          }
        }

        if (this.fromPage != "recharge") {
          // 按之前选择的次卡数组 展示当前的次卡选择情况
          const preSecondaryCardList =
            this.$store.state.eleCard.secondaryCardList;
          if (preSecondaryCardList.length > 0) {
            let resultSelectCardArr = [];
            res.TimesCardPlans.forEach((item) => {
              const itemIndex = preSecondaryCardList.findIndex(
                (sItem) => sItem.Id == item.Id
              );
              if (itemIndex != -1) {
                resultSelectCardArr.push(item.Id);
              } else {
                //除去当前不包括的次卡项
                // this.$store.commit("eleCard/spliceSecondaryCardItem", itemIndex);
              }
            });
            this.secondaryCardResult = resultSelectCardArr;
            // 计算总价、设置所选中的次卡数组
            this.handleSetSecondaryCardPayMoney();
          }
        }
      });
    },
    handleSelectRecharge(item) {
      this.otherMoney = "";
      this.nowActiveRecharge = item;
      this.cardPayMoney = item ? item.RealMoney : 0;
    },
    handleFocusOtherMoneyPrice() {
      this.nowActiveRecharge = {};
      this.cardPayMoney = 0;
    },
    handleInputOtherMoneyPrices(value) {
      // this.otherMoney = value;
      this.cardPayMoney = Number(value);
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    handleChangeSelectStatus(val) {
      this.handleSetSecondaryCardPayMoney();
    },
    handleSetSecondaryCardPayMoney() {
      let saleMoney = 0,
        selectCardArr = [];
      this.secondaryCardResult.forEach((rItem) => {
        const findItem = this.secondaryCardList.find(
          (sItem) => sItem.Id == rItem
        );
        if (findItem) {
          saleMoney += findItem.RealMoney;
          selectCardArr.push({ ...findItem, isSecondary: true });
        }
      });
      this.secondaryCardPayMoney = saleMoney;
      this.selectCardArr = selectCardArr;
    },
    showModel() {
      this.isKnowShow = true;
    },
    confirmBuy() {
      if (!this.isCheck && this.fromPage != "recharge") {
        return this.$toast("请确认您已阅读并同意《办卡须知》");
      }
      // handleLocalStorage.set("secondaryCardList", this.selectCardArr);
      this.$store.commit("eleCard/setSecondaryCardList", this.selectCardArr);
      // handleLocalStorage.set("rechargeInfo", this.nowActiveRecharge);
      this.$store.commit("eleCard/setRechargeInfo", this.nowActiveRecharge);
      this.$router.push({
        name: "CardPay",
        query: {
          cardPayMoney: this.cardPayMoney,
          allPayMoney: this.allPayMoney,
          cardTypeName: this.cardTypeName,
          cardTypeId: this.cardTypeId,
          fromPage: this.fromPage,
        },
      });
    },
    // 点击查看卡详情
    handleClickCard(v) {
      this.isCardShow = true;
      this.detailInfo = v;
    },
  },
};
</script>
<style scoped lang="scss">
.rechargeMoneyPrice {
  padding: 20px;
  background: #fff;
  overflow: auto;

  ul {
    display: flex;
    flex-wrap: wrap;
    .recharge_price_con {
      width: 32%;
      height: 90px;
      background: #f8f8f8;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      margin-right: 10px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &.rechargeActive {
        background: var(--tc);
        color: #fff;
        .price_con {
          color: #fff;
        }
      }
      .price_con {
        color: #e71f19;
        font-size: 20px;
        margin-top: 5px;
      }
    }
  }
}

.txt-box {
  line-height: 40px;
  font-size: 24px;
}
.btm {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: 100%;

  .b-l {
    margin-left: 20px;
  }
  .b-r {
    width: 200px;
    background: var(--tc);
    height: 100%;
    color: #fff;
  }
}
.secondary_card_con {
  padding-bottom: 120px;
}
.counselor_list_con {
  max-height: 40vh;
  overflow: auto;
}
.cark_remark_con {
  padding: 20px;
  li {
    margin-bottom: 20px;
  }
}
.card_img_con {
  text-align: center;
  margin: 30px 0;
  img {
    width: 182px;
    height: 116px;
  }
}
</style>
